import React from 'react';
import MuiDrawer from '@material-ui/core/SwipeableDrawer';

const Drawer = props => <MuiDrawer {...props} />;

Drawer.muiName = 'Drawer';

export default Drawer;
